/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-nested-ternary */
import React, { Suspense, useState, useEffect, useRef, useContext  } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
// import Route from '../routes/Route';

import { CContainer, CFade } from '@coreui/react'
import { useAuth } from '../hooks/auth'
import VideoRoom from '../pages/Vonage/components/VideoRoom'
// routes config
import routes from '../alternativeRoutes.js'
import { useLocation } from 'react-router-dom'
import useRoom from '../pages/Vonage/hooks/useRoom'
import { useVideoCall, VideoCallContext } from '../hooks/videoCallContext'
import { useWebSocketContext } from '../hooks/webSocketContext'
import { TramRounded } from '@material-ui/icons'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
)

const TheContent = () => {
  const { user, usuarioLogadoContemPermissaoAdministrador, lembreDeMim } =
    useAuth()
  const roomId = user ? user._id : null 
  const { 
    roomState,
    setRoomState
  } = useVideoCall(roomId)
  const ehRotaPrivadaOuComUsuarioLogado = route => {
    if (
      route.isPrivate &&
      user &&
      user.comSenhaAutomatica &&
      route.path !== '/alterarSenha'
    ) {
      return false
    }

    if (route.name === 'Login' && lembreDeMim) {
      return false
    }

    return route.isPrivate === !!user
  }

  const redirect = route => {
    if (route.isPrivate) {
      return {
        pathname: '/',
        state: { from: route.path }
      }
    }

    let paginaInicial =
      user.tipoUsuario === 'Cliente'
        ? '/profissional/buscar'
        : '/atendimento/listar'

    if (usuarioLogadoContemPermissaoAdministrador()) {
      paginaInicial = '/profissionais/manter/listar'
    }

    if (user.comSenhaAutomatica) {
      paginaInicial = '/alterarSenha'
    }

    if (
      !user.comSenhaAutomatica &&
      user.perfilIncompleto &&
      user.tipoUsuario === 'Profissional'
    ) {
      paginaInicial = `/profissional/editar/${user.idProfissional}`
    }

    return {
      pathname: paginaInicial,
      state: { from: route.path }
    }
  }

  // Estado para controlar o mini player
  const location = useLocation()
  const miniPlayer = !location.pathname.startsWith('/videoChamada/') 

  // Função para iniciar chamada
  const iniciarChamada = async props => {
    console.log('iniciarChamada')
    setRoomState({
            showVideoRoom: true,
            miniPlayer: false,
            videoRoomProps: props,
            roomRef: {current: null}
    })
  }


  return (
    <main className="c-main">
      <CContainer fluid>
        {/* Mini player sempre montado se showVideoRoom=true */}
        {roomId != null && roomState?.showVideoRoom && roomState?.videoRoomProps && (
          <VideoRoom
            {...roomState.videoRoomProps}
            // eslint-disable-next-line react/jsx-boolean-value
            miniPlayer={miniPlayer}
            onRestore={() => setRoomState({ miniPlayer: false })}
            roomId={roomId}
          />
        )}
        <Suspense fallback={loading}>
          <Switch>
            {routes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    // eslint-disable-next-line react/no-array-index-key
                    key={idx}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={props => (
                      <CFade>
                        {ehRotaPrivadaOuComUsuarioLogado(route) ? (
                            route.path.startsWith('/videoChamada')
                            ? <route.component
                                {...props}
                                iniciarChamada={iniciarChamada}
                            />
                              : <route.component {...props} />
                        ) : (
                          <Redirect to={redirect(route)} />
                        )}
                      </CFade>
                    )}
                  />
                )
              )
            })}
          </Switch>
        </Suspense>
      </CContainer>
    </main>
  )
}

export default React.memo(TheContent)
